module.exports = __webpack_public_path__ + "static/media/danger-icon.7abef154.svg";